export default "__VITE_ASSET__DH6g2QqF__"